/** Code d'état UI — contact absent du Loyalty Engine. */
export const LOYALTY_NOT_ENROLLED = "NOT_ENROLLED";

export function isLoyaltyNotEnrolledError(code) {
    return code === LOYALTY_NOT_ENROLLED;
}

/**
 * Message neutre lorsqu'un contact Unomi n'a pas de profil fidélité.
 * @param {{ email?: string }} options
 */
export function getLoyaltyNotEnrolledMessage({ email } = {}) {
    const normalized = String(email || "").trim();
    if (normalized) {
        return `Aucun profil fidélité trouvé pour ${normalized}.`;
    }
    return "Ce contact n'est pas inscrit au programme de fidélité.";
}

/** Réponse HTTP 404 Loyalty → contact non inscrit (pas une erreur technique). */
export function isLoyaltyNotFoundHttpStatus(status) {
    return status === 404;
}
